import { NumberInput as NumberInputType } from '../../../../../types/Survey/Element'
import { NumberInput as NumberInputAnswerType } from '../../../../../types/Survey/Answer/Element'
import { Props } from './types'
import Core from './Core'
import Number from '../../../../UI/Input/Number'

const NumberInput: React.FC<Props<NumberInputType, NumberInputAnswerType>> = ({ element, answerElement, updateElement }) => {
  const update = (number: number) => {
    updateElement({ ...answerElement, number })
  }

  return (
    <div>
      <Core element={element} answerElement={answerElement} />
      <div className="flex flex-col gap-3 mt-3">
        <Number suffix={element.suffix} key={element.uuid} value={answerElement.number} onChange={update} />
      </div>
    </div>
  )
}

export default NumberInput
